import type { SearchVacantResponse } from 'SearchVacant-Types';

import { fetchMoreSearchVacant, fetchSearchVacant } from './actions';

import { createSlice } from '@reduxjs/toolkit';

export type SearchVacantState = {
  data: SearchVacantResponse;
  isFetching: boolean;
  isFetchingMore: boolean;
};

const initialState: SearchVacantState = {
  data: {} as SearchVacantResponse,
  isFetching: false,
  isFetchingMore: false,
};

const searchVacantSlice = createSlice({
  name: 'searchVacant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle initial fetch
      .addCase(fetchSearchVacant.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchSearchVacant.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchSearchVacant.rejected, (state) => {
        state.isFetching = false;
      })
      // Handle pagination fetch
      .addCase(fetchMoreSearchVacant.pending, (state) => {
        state.isFetchingMore = true;
      })
      .addCase(fetchMoreSearchVacant.fulfilled, (state, action) => {
        state.data = {
          ...action.payload,
          providers: state.data.providers.concat(action.payload.providers),
        };
        state.isFetchingMore = false;
      })
      .addCase(fetchMoreSearchVacant.rejected, (state) => {
        state.isFetchingMore = false;
      });
  },
});

export const searchVacantReducer = searchVacantSlice.reducer;
